import { FieldErrors } from 'react-hook-form';

import { getAllInvoiceDiscrepancies } from './utils';
import { ErrorsNavigationService } from '../errorsNavigation/errorsNavigation';
import { scrollToDiscrepancy } from './navigationHelpers';
import { ConfigItem, InvoiceDiscrepancy } from './types';
import { sortArrayBasedOnConfig } from './ui-helpers';

export class InvoiceDiscrepanciesService extends ErrorsNavigationService<InvoiceDiscrepancy> {
  constructor() {
    super();
  }

  focusOnCurrentError = async (): Promise<void> => {
    const currentError = this.getCurrentError();
    if (currentError) {
      return scrollToDiscrepancy(currentError, this.scrollToVirtualizedRow);
    }
    return scrollToDiscrepancy(this.store.getState().errors[0], this.scrollToVirtualizedRow);
  };

  processDocumentDiscrepancies = <TSection extends ConfigItem>(
    formErrors: FieldErrors,
    data: Record<string, unknown>,
    uiConfig?: Array<TSection>,
  ): void => {
    const discrepancies = getAllInvoiceDiscrepancies(formErrors, data);
    if (!discrepancies || !uiConfig) {
      return;
    }

    const organizedErrors = sortArrayBasedOnConfig(Array.from(Object.values(discrepancies)), uiConfig);
    this.setErrors(organizedErrors);
  };
}
